import { render, staticRenderFns } from "./STLViewer.vue?vue&type=template&id=3e8674a0&scoped=true&"
import script from "./STLViewer.vue?vue&type=script&lang=js&"
export * from "./STLViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8674a0",
  null
  
)

export default component.exports